module.exports = __webpack_public_path__ + "static/media/georgia-tech.6325374a.svg";